import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Plus = function Plus() {
    let _0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    let _ref = [
        _0
    ], [_ref1 = {
        height: 24,
        width: 24
    }] = _ref, { height = 24, width = 24 } = _ref1, props = _object_without_properties(_ref1, [
        "height",
        "width"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 11H13V5C13 4.44771 12.5523 4 12 4C11.4477 4 11 4.44771 11 5V11H5C4.44771 11 4 11.4477 4 12C4 12.5523 4.44771 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z",
            fill: "currentColor"
        })
    }));
};
